'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Dropdown = function (_Component) {
  (0, _inherits3.default)(Dropdown, _Component);

  function Dropdown(props) {
    (0, _classCallCheck3.default)(this, Dropdown);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Dropdown.__proto__ || (0, _getPrototypeOf2.default)(Dropdown)).call(this, props));

    _this.state = {
      isOpen: false
    };

    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Dropdown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('click', this.handleClickOutside);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClickOutside);
    }
  }, {
    key: 'handleClickOutside',
    value: function handleClickOutside(e) {
      if (this.node && !this.node.contains(e.target) && this.state.isOpen) {
        this.setState({ isOpen: false });
      }
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      e.preventDefault();
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          id = _props.id,
          style = _props.style;
      // XXX: the reason to use <li> is just to follow the original design mockup, can be changed when needed

      return _react2.default.createElement(
        'li',
        { className: className, id: id, style: style, ref: function ref(node) {
            _this2.node = node;
          } },
        _react2.default.cloneElement(this.props.children[0], {
          onClick: function onClick(e) {
            return _this2.toggle(e);
          },
          className: '' + (this.props.children[0].props.className || '') + (this.state.isOpen ? ' active' : '')
        }),
        this.state.isOpen && this.props.children[1]
      );
    }
  }]);
  return Dropdown;
}(_react.Component); // Dropdown

Dropdown.propTypes = {
  children: _react.PropTypes.array.isRequired,
  className: _react.PropTypes.string,
  id: _react.PropTypes.string,
  style: _react.PropTypes.object
};

exports.default = Dropdown;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Dropdown.js
// module id = 572
// module chunks = 0